import { useEffect, useState } from "react";
import * as mobileUserManagementService from "../../../../services/mobileUserManagementService";
import useGetMobileUserList from "../../../../hooks/useGetMobileUserList";
import useValue from "../../../../hooks/useValue";
import { CustomNotification } from "../../../../util/CustomNotification";
import { UserTypeConstants } from "../../../../constants/DatabaseConstants/MasterConstant";
import { GetAllMobileUserResponse } from "../../../../shared/interface/UserManagement/mobileUser.interface";

export const useMobileUserList = (props: { searchedText: string | undefined }) => {
  /* STATE */
  const [userId, setUserId] = useState<number | null>(null);
  const [userName, setUserName] = useState<string | null>(null);
  const [isActive, setIsActive] = useState(false);

  /* CUSTOM HOOKS */
  const { loading, userList, handleRefetchUserList, pagination, filteredTableData, handleFilterTableData, handleChangePagination } = useGetMobileUserList(UserTypeConstants.REGULAR);
  const { value: showDeleteModal, handleEnableValue: handleShowDeleteModal, handleDisableValue: handleHideDeleteModal } = useValue(false);
  const { value: saving, handleEnableValue: handleEnableSaving, handleDisableValue: handleDisableSaving } = useValue(false);

  /* HANDLERS */
  const handleDeleteUser = (record: GetAllMobileUserResponse) => {
    setUserId(record?.id);
    setIsActive(record?.is_active);
    setUserName(record?.first_name);
    handleShowDeleteModal();
  };

  const deleteUserById = async (userId: number | null, isActive: boolean) => {
    try {
      if (!userId) return;
      handleEnableSaving();
      await mobileUserManagementService.deleteUser(userId);
      CustomNotification.showSuccessMessage(`User ${isActive ? "Inactivated" : "Activated"} Successfully.`);
      handleRefetchUserList();
    } catch (error) {
      CustomNotification.showErrorMessage(error);
    } finally {
      handleDisableSaving();
      resetState();
    }
  };

  const handleOk = () => {
    deleteUserById(userId, isActive);
  };

  const resetState = () => {
    setUserId(null);
    setIsActive(false);
    setUserName(null);
    handleHideDeleteModal();
  };

  const handleCancel = () => {
    resetState();
  };

  /* EFFECTS */
  useEffect(() => {
    handleFilterTableData(props.searchedText);
    // eslint-disable-next-line
  }, [props.searchedText]);

  return { loading, userList, userId, filteredTableData, pagination, saving, handleChangePagination, handleDeleteUser, handleCancel, handleOk, showDeleteModal, isActive, userName };
};
